import api from '~/services/api';
import PropTypes from 'prop-types';
import errorHandler from '~/Utils/errorHandler';
import { message } from 'antd';
import i18next from 'i18next';

const endPoint = 'notificationUsers';

// PAGINATION
export const paginationNotifications = async params => {
  try {
    const { data } = await api.post(`/${endPoint}/pagination`, params);
    return data;
  } catch (error) {
    errorHandler(error);
  }
};

// FIND ALL
export const findAllNotifications = async (filters) => {
  try {
    const { data } = await api.post(`/${endPoint}/findAll`, filters);
    return data;
  } catch (error) {
    errorHandler(error);
  }
};

// COUNT UN READ
export const countUnReadNotifications = async () => {
  try {
    const { data } = await api.post(`/${endPoint}/countUnRead`);
    return data;
  } catch (error) {
    errorHandler(error);
  }
};

// CREATE
export const createNotification = async values => {
  try {
    const { data } = await api.post(`/${endPoint}/create`, values);
    message.success(i18next.t(`messages:${endPoint}.success`));
    return data;
  } catch (error) {
    errorHandler(error);
  }
};

// UPDATE
export const updateNotification = async values => {
  try {
    const { data } = await api.put(`/${endPoint}/update`, values);
    message.success(i18next.t(`messages:${endPoint}.successEdit`));
    return data;
  } catch (error) {
    errorHandler(error);
  }
};

// DELETE
export const deleteNotification = async id => {
  try {
    const { data } = await api.delete(`/${endPoint}/delete/${id}`);
    message.success(i18next.t(`messages:${endPoint}.successDeleted`));
    return data;
  } catch (error) {
    errorHandler(error);
  }
};

// UPDATE VIEWED
export const updateViewedNotification = async values => {
  try {
    const { data } = await api.put(`/${endPoint}/updateViewed`, values);
    return data;
  } catch (error) {
    errorHandler(error);
  }
};

paginationNotifications.propTypes = {
  params: PropTypes.object.isRequired,
};

findAllNotifications.propTypes = {
  filters: PropTypes.object.isRequired,
};

createNotification.propTypes = {
  values: PropTypes.object.isRequired,
};

updateNotification.propTypes = {
  values: PropTypes.object.isRequired,
};

deleteNotification.propTypes = {
  id: PropTypes.string.isRequired,
};

updateViewedNotification.propTypes = {
  values: PropTypes.object.isRequired,
};
